/**
 * const page 简历属性
 */
const cvPage = {
  cvPages: 1, // 总页数
  cvHeight: 0,  // cv总高度
  pageHeight: 0 // A4纸内容高度
}
/**
 * cvs
 */
const cvs = {
  cvs: [], // 简历列表
  cv: {}, // 简历
  editorCvToken: '', // /cvs/token/editor 正在编辑的cv token
  oldLineHeight: 12, // 一页纸之前行高
  templates: [], // 简历模板
  temps: [], // 简历模板
  downloadCv: '', // 下载简历
  autoOnePage: '', // 自动一页纸
}
const state = () => ({
  ...cvs,
  ...cvPage,
  cvsData: {},
  recommendTemplate: [],
  rate: {},
  sortAry: [],
  pageIndex: null,
  profiles: {},
  others: {},
  check: {}, // 简历检查信息,
  editCheckData: {}, // 优化建议跳转数据
  highlightShow: false, // 优化建议显示

  isAutoOnePage: false, // 是否自动一页纸
  section_titles: '',   // 默认模块标题
})

export default state
